import { forwardRef, type SVGProps } from 'react';

export type BoardsListProps = {} & Omit<SVGProps<SVGSVGElement>, 'css'>;

export const BoardsList = forwardRef<SVGSVGElement, BoardsListProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="currentColor" viewBox="0 0 32 32">
    <path
      d="M28 21H17m11.13 5.06H17M12 20H4v8h8zM28 5H17m11 5H17m-5-6H4v8h8z"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
));
BoardsList.displayName = 'BoardsList';
